import { LoadableAfterPaint } from '@confluence/loadable';

export const PageAnalyticsPageLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsPageAnalyticsPage" */ '../src/components/PageAnalytics/PageAnalyticsPage'
			)
		).PageAnalyticsPage,
});
